// extracted by mini-css-extract-plugin
export default {"tooltip":"Tm-z","sharingV2":"Um-z","sharingIconsV2":"Vm-z","links":"Wm-z","link":"Xm-z","facebookV2":"Ym-z","twitterV2":"Zm-z","pinterestV2":"_m-z"};